import { FilterButtonBase } from './Base';
import { FilterButtonDropDown } from './DropDown';

export const FilterButton = {
  Base: FilterButtonBase,
  DropDown: FilterButtonDropDown,
};
